import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProduct } from '../hooks/useProducts';
import ProductDisplay from '../componnents/ProductDisplay/ProductDisplay';
import RelatedProducts from '../componnents/RelatedProducts/RelatedProducts';
import { LoadingSpinner, ErrorMessage } from '../componnents/UI';
import { getProductId, canViewProductPage } from '../utils/helpers';
import './CSS/product.css';

const Product = () => {
  const { t } = useTranslation(['products', 'common']);
  const { productId } = useParams();
  const { data: product, isLoading, error } = useProduct(productId);

  if (isLoading) {
    return (
      <div className="product-page">
        <LoadingSpinner text={t('loading', { defaultValue: 'Loading product...' })} fullPage />
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="product-page">
        <div className="product-error">
          <ErrorMessage
            variant="fullPage"
            message={error?.message || t('productNotFound', { ns: 'products' })}
          />
          <Link to="/" className="back-home-btn">{t('backToHome', { defaultValue: 'Back to Home', ns: 'common' })}</Link>
        </div>
      </div>
    );
  }

  if (!canViewProductPage(product)) {
    return (
      <div className="product-page">
        <div className="product-error">
          <ErrorMessage
            variant="fullPage"
            message={t('productNotFound', { ns: 'products' })}
          />
          <Link to="/" className="back-home-btn">{t('backToHome', { defaultValue: 'Back to Home', ns: 'common' })}</Link>
        </div>
      </div>
    );
  }

  const categoryId = product.category?._id || product.category?.id || product.categoryId;

  return (
    <div className="product-page">
      <ProductDisplay product={product} />
      <RelatedProducts categoryId={categoryId} currentProductId={getProductId(product)} />
    </div>
  );
};

export default Product;
